import i18n from 'i18next';

import AtlasSdk from '@atlas/sdk';
import { baseConfirm } from '@case-management/components/src/modal-pro/confirm';
import errorReporterClient from '@/config/reporter';

import { BaseError, CancelError, IgnoreError, AuthorizationError, NetworkError, TimeoutError } from './error';
import { AccessErrorCode, WarningCodes } from './code';
import { rules, ErrorMessageType, ModalConfig, NotificationConfig } from './rules';
import { hash, createThrottlePool } from './utils';

export { ErrorMessageType } from './rules';

const throttlePool = createThrottlePool();

export function show(type: ErrorMessageType.NOTIFICATION, content: NotificationConfig): void;
export function show(type: ErrorMessageType.MODAL, content: ModalConfig): void;
export function show(type: ErrorMessageType, content: NotificationConfig | ModalConfig) {
  if (type === ErrorMessageType.NOTIFICATION) {
    throttlePool(`${hash(JSON.stringify(content))}`, () => {
      AtlasSdk.toast.show({
        dismissible: true,
        dismissDelay: AtlasSdk.toast.delays.MEDIUM,
        ...(content as NotificationConfig),
      });
    });
  } else if (type === ErrorMessageType.MODAL) {
    throttlePool(`${hash(JSON.stringify(content))}`, () => {
      baseConfirm(content as ModalConfig);
    });
  }
}

export function hanleError(error: BaseError) {
  if (
    error instanceof IgnoreError ||
    error instanceof CancelError ||
    error instanceof NetworkError ||
    Object.values(AccessErrorCode).flat(Infinity).includes(error.code)
  )
    return;

  if (error instanceof AuthorizationError) {
    AtlasSdk.lifecycle.showError({
      errorType: AtlasSdk.lifecycle.errorTypes.UNAUTHORIZED,
    });
  } else {
    const rule = rules.find((v) => v.reg.test(error.code));
    if (rule) {
      // @ts-ignore
      show(rule.type, rule.get());
    } else {
      if (i18n.exists(`errorCode.${error.code}`)) {
        const isWarning = WarningCodes.includes(error.code);
        show(ErrorMessageType.NOTIFICATION, {
          type: isWarning ? AtlasSdk.toast.types.WARNING : AtlasSdk.toast.types.DANGER,
          title: i18n.t('common.message'),
          message: i18n.t(`errorCode.${error.code}`, { defaultValue: i18n.t('common.error') }),
        });
      } else {
        show(ErrorMessageType.NOTIFICATION, {
          type: AtlasSdk.toast.types.WARNING,
          title: i18n.t('errorCode.server_error_title'),
          message: i18n.t('errorCode.server_error_message'),
        });
      }
    }
  }
}

export function notify(error: BaseError) {
  if (
    error instanceof IgnoreError ||
    error instanceof CancelError ||
    error instanceof NetworkError ||
    Object.values(AccessErrorCode).flat(Infinity).includes(error.code) ||
    (i18n.exists(`errorCode.${error.code}`) && ![TimeoutError.CODE].includes(error.code))
  )
    return;
  errorReporterClient.notify(error);
}
